/* eslint-disable no-unsafe-optional-chaining */
import { APPOINTMENTS_STATUS } from '../../../../../services/appointments'

export const BadgeStatus = ({ status }) => {
  const statusStyles = {
    [APPOINTMENTS_STATUS.COMPLETED]: { backgroundColor: '#ECF8DD', color: '#7FBD31' },
    [APPOINTMENTS_STATUS.CANCELED]: { backgroundColor: '#f9e0e0', color: '#ff7a7a' },
    [APPOINTMENTS_STATUS.NO_SHOW]: { backgroundColor: '#f9e0e0', color: '#ff7a7a' },
    [APPOINTMENTS_STATUS.REQUESTED]: { backgroundColor: '#e2e3e5', color: '#383d41' },
    [APPOINTMENTS_STATUS.ASSIGNED]: { backgroundColor: '#e0f2ff', color: '#007bd0' },
  };

  return (
    <span
      className="badge"
      style={{
        ...(statusStyles[status.code] || { backgroundColor: '#e2e3e5', color: '#383d41' }),
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: 500,
      }}
    >
      {status?.name?.toUpperCase()}
    </span>
  );
};
